import fetch from '@/utils/fetch';
import {systemFetch,wymsFetchNoProcess} from '@/utils/fetch';
export function getWxfileInfoSchoolList(args) {
    const params = new URLSearchParams();
    params.append('areaCode', args.areaCode);
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('schoolType', args.schoolType);
    params.append('searchTitle', args.searchTitle);
    return fetch({
        url: 'structure/wxfileInfo/getWxfileInfoSchoolList',
        method: 'get',
        params
    });
}
export function updateWxfileInfoSchool(args) {
    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/wxfileInfo/updateWxfileInfoSchool',
        method: 'POST',
        data: JSON.stringify(args)
    });
  }

  export function delWxfileInfoByWxfileInfoId(args) {
    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/wxfileInfo/delWxfileInfoByWxfileInfoId',
        method: 'POST',
        data: JSON.stringify(args)
    });
  }

  export function getWxfileInfoList(args) {
    const params = new URLSearchParams();
    params.append('moduleCode', args.moduleCode);
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('startDate', args.startDate);
    params.append('endDate', args.endDate);
    params.append('schoolId', args.schoolId);
    return fetch({
        url: 'structure/wxfileInfo/getWxfileInfoList',
        method: 'get',
        params
    });
}

export function getWxfileInfoSchool(schoolId) {
    const params = new URLSearchParams();
    params.append('schoolId', schoolId);
    return fetch({
        url: 'structure/wxfileInfo/getWxfileInfoSchool',
        method: 'get',
        params
    });
}
//获得学校安装的模块列表
export function queryBySchoolId(schoolId) {
    return systemFetch({
      url: 'api/module/school/queryBySchoolId?schoolId='+schoolId,
      method: 'get'
    });
  }

  export function delWxfileInfoAll(args) {
    const params = new URLSearchParams();
    params.append('moduleCode', args.moduleCode);
    params.append('startDate', args.startDate);
    params.append('endDate', args.endDate);
    params.append('schoolId', args.schoolId);
    return fetch({
        url: 'structure/wxfileInfo/delWxfileInfoAll',
        method: 'get',
        params
    });
}


// WEBPACK FOOTER //
// ./src/api/resourceusage.js